import { COLORS, newLayout } from '../theme';

export default {
  styleOverrides: {
    root: {
      backgroundColor: COLORS.black10,

      '&.MuiSkeleton-circular': {
        height: '28px',
        borderRadius: 100,
      },

      '&.MuiSkeleton-rounded': {
        borderRadius: newLayout.borderRadius.secondary,
      },

      '&.MuiSkeleton-text': {
        borderRadius: newLayout.borderRadius.secondary,
        transform: 'none',
      },
    },
  },
};
